import Vue from 'vue';
import ErrorList from '@/Shared/ErrorList.vue';

const ErrorListMixin = Vue.extend({
    components: { ErrorList },
    data() {
        return {
            errors: {} as () => {[key: string]: string}
        };
    },
    methods: {
        addError(key: string, message: string) {
            Vue.set(this.errors, key, message);
        },
        clearError(key: string) {
            Vue.delete(this.errors, key);
        },
        clearAllErrors() {
            this.errors = {} as () => {[key: string]: string};
        }
    },
});

export default ErrorListMixin;
